import { useInView } from '../../hooks/useInView';
import { Star } from 'lucide-react';

const testimonials = [
{ name: "Rahul T", age: 36, text: 'Within weeks I noticed a clear increase in volume and improved libido. I was sceptical at first but RELOAD has genuinely made a difference. My partner noticed too.', stars: 5 },
{ name: "Daniel T", age: 45, text: "I've tried other supplements before but nothing like this. The natural formula means no jitters or side effects. By week 3 I felt 10 years younger. Highly recommend.", stars: 5 },
{ name: "Armando M", age: 43, text: 'As someone who is health-conscious and only uses natural supplements, RELOAD ticks all the boxes. The ingredient quality is clearly premium. Already on my third bottle.', stars: 5 },
{ name: "Simon H", age: 51, text: "My energy levels and confidence in the bedroom have noticeably improved. I was experiencing a real decline and this has genuinely helped me get back to my best.", stars: 5 },
{ name: "Chris M", age: 35, text: 'Clean formula, no fillers, real results. Volume increase was noticeable from week 2 onwards. This is the real deal for any man looking to optimise reproductive health.', stars: 5 },
{ name: "Anthony B", age: 44, text: "RELOAD has become a non-negotiable part of my daily routine. The libido support alone is worth it. Everything about this product feels premium — from the bottle to the results.", stars: 5 }];


export default function TestimonialsSection() {
  const [ref, inView] = useInView(0.05);

  return (
    <section
      data-testid="testimonials-section"
      style={{ backgroundColor: '#F7F7F5', padding: '96px 0' }}>

      <div ref={ref} className="max-w-7xl mx-auto px-6 md:px-12">
        <div className={`text-center mb-14 fade-up ${inView ? 'visible' : ''}`}>
          <span className="overline block mb-4">Real Men. Real Results.</span>
          <h2 style={{
            fontFamily: 'Outfit, sans-serif',
            fontWeight: 800,
            fontSize: 'clamp(1.8rem, 4vw, 2.8rem)',
            color: '#0D1A2E',
            letterSpacing: '-0.025em',
            marginBottom: '14px'
          }}>
            Men Are Feeling the Difference
          </h2>
          <div className="flex items-center justify-center gap-3">
            <div className="flex gap-0.5">
              {[...Array(5)].map((_, i) => <Star key={i} size={18} fill="#1B3D7E" stroke="#1B3D7E" />)}
            </div>
            <span style={{ fontFamily: 'Manrope, sans-serif', fontSize: '0.88rem', color: '#64748B', fontWeight: 600 }}>
              4.9 / 5 — 2,000+ reviews
            </span>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {testimonials.map((t, i) =>
          <div
            key={t.name}
            data-testid={`testimonial-card-${i}`}
            className={`card-light card-hover rounded-2xl p-7 fade-up delay-${Math.min(i + 1, 4)} ${inView ? 'visible' : ''}`}>

              <div className="flex gap-0.5 mb-4">
                {[...Array(t.stars)].map((_, si) => <Star key={si} size={13} fill="#1B3D7E" stroke="#1B3D7E" />)}
              </div>
              <p style={{ fontFamily: 'Manrope, sans-serif', fontSize: '0.88rem', color: '#0D1A2E', lineHeight: 1.85, marginBottom: '18px', fontStyle: 'italic' }}>
              &ldquo;{t.text}&rdquo;
              </p>
              <div className="flex items-center justify-between">
                <div>
                  <p style={{ fontFamily: 'Outfit, sans-serif', fontWeight: 700, color: '#0D1A2E', fontSize: '0.88rem' }}>{t.name}, {t.age}</p>
                  <p style={{ fontFamily: 'Manrope, sans-serif', fontSize: '0.7rem', color: '#1B3D7E', letterSpacing: '0.1em', marginTop: '2px', textTransform: 'uppercase', fontWeight: 700 }}>Verified Purchase</p>
                </div>
                <div style={{ width: '36px', height: '36px', borderRadius: '50%', backgroundColor: 'rgba(27,61,126,0.09)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'Outfit, sans-serif', fontWeight: 800, color: '#1B3D7E', fontSize: '0.9rem' }}>
                  {t.name.charAt(0)}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>);

}